<template>
    <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">Call records</h4>
            <CDRTable></CDRTable>
    </card>
</template>

<script>
    import CDRTable from "./CDRTable";

    export default {
        name: "CDRTableFull",
        components: {
            CDRTable,
        },
    }
</script>
